// hooks/useGetAssessments.js
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { assessmentService } from '../Services/assessmentService';
import { setSuccessSnack } from '../Reducers/snackSuccess';
import { handleApiError } from '../Utils/ApiErrorHandler';

const useGetAssessments = () => {
  const dispatch = useDispatch();
  const [assessments, setAssessments] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const fetchAssessments = async () => {
    try {
      setLoading(true);
      const data = await assessmentService.getAssessments();
      setAssessments(data);
      return data;
    } catch (error) {
      handleApiError(error, dispatch, 'get assessments');
      return null;
    } finally {
      setLoading(false);
    }
  };

  const getAssessmentQuestions = async (id, groupQuestions) => {
    if (!id) return null;
    try {
      setLoading(true);
      const data = await assessmentService.getAssessmentQuestions(id);
      return data;
    } catch (error) {
      handleApiError(error, dispatch, 'get assessment questions');
      return null;
    } finally {
      setLoading(false);
    }
  };

  const deleteAssessment = async (id) => {
    if (!id) return false;

    try {
      setDeleting(true);
      const data = await assessmentService.deleteAssessment(id);
      
      if (data.status === 'Removed') {
        dispatch(setSuccessSnack({
          title: 'Success', 
          body: 'Removed assessment'
        }));
        return true;
      }
      return false;
    } catch (error) {
      handleApiError(error, dispatch, 'delete assessment');
      return false;
    } finally {
      setDeleting(false);
    }
  };

  const fetchAssessmentSessions = async () => {
    try {
      setLoading(true);
      const data = await assessmentService.getAssessmentSessions();
      setSessions(data);
      return data;
    } catch (error) {
      setSessions([]);
      handleApiError(error, dispatch, 'get assessment sessions');
      return null;
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    fetchAssessments();
  }, []);

  return {
    sessions,
    assessments,
    loading,
    deleting,
    fetchAssessments,
    getAssessmentQuestions,
    deleteAssessment,
    fetchAssessmentSessions,
  };
};

export default useGetAssessments;